var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H50V50H0z",
    transform: "translate(-983.000000, -1099.000000) translate(948.000000, 1064.000000) translate(35.000000, 35.000000)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4884E8",
    d: "M45.78 33.48c.216.37.276.81.167 1.225-.11.414-.378.767-.748.983L25.823 46.991c-.247.144-.528.22-.814.22-.286 0-.566-.076-.813-.22L4.819 35.688c-.184-.106-.346-.247-.476-.416-.13-.17-.225-.362-.28-.568-.054-.206-.068-.42-.04-.631.029-.211.099-.415.206-.599.107-.183.25-.344.42-.473.17-.129.363-.222.569-.276.206-.053.42-.066.632-.036.21.03.413.101.597.21l18.562 10.828 18.563-10.828c.37-.216.81-.276 1.224-.167.415.11.768.378.984.748zm-2.208-10.27L25.009 34.04 6.446 23.21c-.183-.11-.386-.183-.598-.214-.211-.03-.427-.02-.634.034-.207.053-.402.146-.572.275-.171.13-.314.29-.422.475-.108.185-.178.39-.206.601-.028.212-.014.428.042.634.056.207.152.4.283.569.131.169.295.31.48.415l19.377 11.303c.247.144.527.22.813.22.286 0 .567-.076.814-.22L45.199 26c.367-.217.633-.57.74-.983.107-.413.047-.851-.168-1.22-.215-.368-.567-.636-.979-.746-.412-.11-.85-.053-1.22.16zM4.018 14.918c0-.282.074-.56.215-.804.14-.245.343-.448.587-.59L24.196 2.22c.247-.144.527-.22.813-.22.286 0 .567.076.814.22l19.376 11.303c.244.142.446.345.587.59.14.245.214.522.214.804 0 .283-.074.56-.214.805-.14.244-.343.448-.587.59L25.823 27.615c-.247.144-.528.22-.814.22-.286 0-.566-.076-.813-.22L4.819 16.312c-.243-.142-.446-.346-.586-.59-.14-.245-.215-.522-.215-.805zm4.82 0l16.171 9.434 16.172-9.434-16.172-9.433-16.171 9.433z",
    transform: "translate(-983.000000, -1099.000000) translate(948.000000, 1064.000000) translate(35.000000, 35.000000)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaking);
export default __webpack_public_path__ + "static/media/staking.7b67fb65.svg";
export { ForwardRef as ReactComponent };